import "./Template4.scss";

export function Template4({ resumeData }) {
  function addEducation(value) {
    return (
      <>
        <span className="disp-block flt-right">
          {value?.graduationDate && (
            <span>
              <span className="xslt_static_change displayNoneThisField">Expected in </span>
              <span>{value?.graduationDate}</span>
            </span>
          )}
        </span>
        <span className="educ-location">
          <span className="txt-bold">{value?.degreeEarned}</span>
        </span>
        <span className="disp-block txt-italic">
          <span>{value?.institutionName} </span>
          <span>
            <span>, </span>
          </span>
          <span> {value?.location}</span>
        </span>
      </>
    );
  }

  function addWorkExpireance(value) {
    const dateRange =
      value?.endDate === "Present" ? `${value?.startDate} - Present` : `${value?.startDate} - ${value?.endDate}`;
    return (
      <>
        <span className="disp-block inner-date flt-right">
          <span>{dateRange}</span>
        </span>
        <span className="disp-block locationGap">
          <span className="jobtitle disp-block txt-bold">{value?.jobTitle}</span>
          <span className="txt-italic add-txt">
            <span className="company-name">{value?.companyName}</span>
            <span></span>
            <span>{value?.location}</span>
          </span>
        </span>
        <span className="jobline">
          <ul>
            {value?.responsibilities &&
              value?.responsibilities.map((responsibility, index) => <li key={index}>{responsibility}</li>)}
          </ul>
        </span>
      </>
    );
  }

  function projectExpireance(value) {
    const dateRange =
      value.endDate === "Present" ? `${value?.startDate} - Present` : `${value?.startDate} - ${value?.endDate}`;

    return (
      <>
        <h3>
          {value?.startDate || (value?.endDate && <span>{dateRange} &nbsp; &nbsp;</span>)}
          <span>
            <strong>{value.projectName}</strong>
          </span>
        </h3>
        <a href={value?.projectLink}>{value?.projectLink}</a>
        {value?.projectDescription && <p>Description: {value?.projectDescription}</p>}
        {value?.roleResponsibility && <p>Responsibility:{value?.roleResponsibility}</p>}

        <ul style={{ display: "flex", flexWrap: "wrap" }}>
          {value?.technologiesUsed &&
            value?.technologiesUsed.map((technology, index) => (
              <li style={{ width: "150px" }} className="technology" key={index}>
                {technology}
              </li>
            ))}
        </ul>
      </>
    );
  }

  return (
    <div className="document doc-root fontsize fontface vmargins hmargins pagesize skn-sli2 SLI2 RNA">
      <div className="name-contact">
        <div className="section name-sec SECTION_NAME">
          <div className="doc-item">
            <div className="paragraph PARAGRAPH_NAME firstparagraph">
              <div className="name">
                <span>
                  <span>Hi, I’m </span>
                </span>
                <span> </span>
                <span>
                  {resumeData?.PersonalInformation?.firstName} {resumeData?.PersonalInformation?.lastName}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="section notdraggable cntc-sec SECTION_CNTC" id="personalInformation">
          <div className=" doc-item">
            <div className="paragraph PARAGRAPH_CNTC firstparagraph">
              <div className="clearfix doc-item">
                <div className="address">
                  <div className="paddedline">
                    <div className="icon-row">
                      {resumeData?.PersonalInformation?.phoneNumber && (
                        <span className="icon-field">
                          <span className="icon-svg">
                            <svg width="8px" height="9px" viewBox="0 0 9 9">
                              <path
                                d="M7.9854443,7.27045638 C7.92071892,7.6081571 7.82028298,7.88371151 7.67632481,8.11470818 C7.52232304,8.35743057 7.32368308,8.54738723 7.06812942,8.69513129 C6.7177196,8.89798624 6.33606304,9 5.92873952,9 C5.62296789,9 5.30157289,8.94254397 4.96567049,8.8288045 C4.28828589,8.59898039 3.63880017,8.16747392 3.14889599,7.81570234 C2.67573114,7.47682904 2.2416247,7.052358 1.82090973,6.52118291 C1.37452779,6.01345926 1.0330456,5.50456303 0.775260033,4.96752508 C0.50743087,4.41172598 0.184919919,3.67769594 0.0577010666,2.94249333 C-0.0896049732,2.0912061 0.0454255633,1.36069378 0.459444812,0.769717519 C0.632417813,0.522304838 0.83886946,0.341728759 1.08772739,0.212745845 C1.32319386,0.0931435066 1.5966028,0.0239617618 1.92469353,0.00168289489 C2.11552181,-0.0112153965 2.37553928,0.0438954849 2.52507723,0.382768777 C2.64560036,0.65597804 2.77281921,0.932705019 2.89445829,1.20005142 C2.98373468,1.39235322 3.07412702,1.59051788 3.16228745,1.78750997 C3.21920115,1.91414774 3.26607125,2.04195808 3.30289776,2.16625071 C3.37431887,2.41366339 3.30959349,2.61651833 3.1042578,2.78771384 C2.8397765,3.00698479 2.58087498,3.22273803 2.33536491,3.44200898 C2.32532132,3.45138956 2.30523413,3.46897814 2.29295863,3.48187643 C2.29630649,3.49477472 2.30411817,3.5205713 2.3208575,3.56161132 C2.57194734,4.21356132 2.87883492,4.74825413 3.25602766,5.19383147 L3.26160743,5.2008669 C3.63433635,5.6523071 4.09745761,6.04160098 4.67887009,6.38985485 C4.7156966,6.41330629 4.7380157,6.42385944 4.75140715,6.42854972 C4.76479861,6.41682401 4.78376985,6.400408 4.79381344,6.39102742 C5.03262778,6.16237589 5.2692102,5.92199864 5.51248836,5.67575854 C5.69996877,5.48462931 5.90084065,5.44241672 6.12403162,5.55029334 C6.23785901,5.60423165 6.35057045,5.67106825 6.46328189,5.74611285 C6.63625489,5.86454262 6.8114598,5.98531753 6.98220089,6.10257472 C7.21878332,6.26556222 7.46206148,6.43324001 7.70422368,6.59505494 C8.00553149,6.79556474 8.02338677,7.07229172 7.9854443,7.27045638"
                                mask="url(#mask-2)"
                              ></path>
                            </svg>
                          </span>
                          <span className="ico-txt">
                            <span>{resumeData?.PersonalInformation?.phoneNumber}</span>
                          </span>
                        </span>
                      )}
                      {resumeData?.PersonalInformation?.emailAddress && (
                        <span className="icon-field">
                          <span className="icon-svg email">
                            <svg width="8px" x="0px" y="0px" viewBox="0 0 8 6" xml:space="preserve">
                              <path d="M7.8,0C7.9,0,8,0.1,8,0.2v5.6C8,5.9,7.9,6,7.8,6H0.2C0.1,6,0,5.9,0,5.8V0.2C0,0.1,0.1,0,0.2,0H7.8z M8,0.9L4.5,2.7 c-0.1,0-0.7,0-0.8,0L0,0.9c0,0.1,0,1,0,1L3.8,4c0,0,0.5,0,0.5,0L8,1.9"></path>
                            </svg>
                          </span>
                          <span className="ico-txt">{resumeData?.PersonalInformation?.emailAddress}</span>
                        </span>
                      )}
                      {resumeData?.PersonalInformation?.mailingAddress && (
                        <span className="icon-field">
                          <span className="icon-svg">
                            <svg width="8px" height="10px" viewBox="0 0 9 11">
                              <path
                                fill="#46464e"
                                d="M4.098 6.318c-1.02 0-1.85-.83-1.85-1.85s.83-1.85 1.85-1.85 1.85.83 1.85 1.85-.83 1.85-1.85 1.85zm0-5.528A3.682 3.682 0 0 0 .42 4.468c0 2.517 3.291 6.211 3.431 6.367a.331.331 0 0 0 .493 0c.14-.156 3.432-3.85 3.432-6.367A3.682 3.682 0 0 0 4.098.79z"
                              ></path>
                            </svg>

                            <span>{resumeData?.PersonalInformation?.mailingAddress}</span>
                          </span>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="parent-wrapper">
        {resumeData?.ProfessionalSummary?.summary && (
          <div className="section SECTION_SUMM has-title" id="summary">
            <div className=" doc-item">
              <div className="heading">
                <div className="sectiontitle">
                  Summary<span className="rename-section text-rename"></span>
                </div>
              </div>

              <div className="paragraph PARAGRAPH_SUMM firstparagraph">
                <div className="clearfix doc-item">
                  <div className="singlecolumn">
                    <p>{resumeData?.ProfessionalSummary?.summary}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {resumeData?.Skills?.length > 0 && (
          <div className="section SECTION_HILT has-title" id="skill">
            <div className=" doc-item">
              <div className="heading">
                <div className="sectiontitle">
                  Skills<span className="rename-section text-rename"></span>
                </div>
              </div>

              <div className="paragraph PARAGRAPH_HILT firstparagraph">
                <div className="clearfix doc-item">
                  <div className="singlecolumn maincolumn">
                    <div className="skill">
                      <span className="paddedline">
                        <ul style={{ display: "flex", flexWrap: "wrap" }}>
                          {resumeData?.Skills.map((skill, index) => (
                            <li className="skills" key={index}>
                              {skill}
                            </li>
                          ))}
                        </ul>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div>
          {resumeData?.WorkExperience?.length > 0 && (
            <div className="section expr-sec SECTION_EXPR multi-para has-title" id="workExperience">
              <div className=" doc-item">
                <div className="heading">
                  <div className="sectiontitle">
                    Experience<span className="rename-section text-rename"></span>
                  </div>
                </div>
                <div className="sortableInner">
                  <div className="sortable-item paragraph-container SortableItem-sibling ">
                    <div className="paragraph PARAGRAPH_EXPR firstparagraph">
                      <div className="clearfix doc-item">
                        <div className="singlecolumn">
                          {resumeData.WorkExperience.map((e, index) => (
                            <div style={{ marginBottom: "10px" }} className="printable-content" key={index}>
                              {addWorkExpireance(e)}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {resumeData?.Education?.length > 0 && (
            <div className="section educ-sec SECTION_EDUC multi-para has-title" id="education">
              <div className=" doc-item">
                <div className="heading">
                  <div className="sectiontitle">
                    Education<span className="rename-section text-rename"></span>
                  </div>
                </div>
                <div>
                  <div>
                    <div className="paragraph PARAGRAPH_EDUC firstparagraph">
                      <div className="clearfix doc-item">
                        <div className="singlecolumn">
                          {resumeData?.Education.map((e, index) => (
                            <div style={{ marginBottom: "10px" }} className="printable-content" key={index}>
                              {addEducation(e)}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {resumeData?.Project?.length > 0 && (
            <div className="section educ-sec SECTION_EDUC   multi-para has-title  " id="project">
              <div className=" doc-item">
                <div className="heading">
                  <div className="sectiontitle">
                    Project<span className="rename-section text-rename"></span>
                  </div>
                </div>
                <div>
                  <div>
                    <div className="paragraph PARAGRAPH_EDUC firstparagraph">
                      <div className="clearfix doc-item">
                        <div className="singlecolumn">
                          {resumeData?.Project.map((e, index) => (
                            <div style={{ marginBottom: "10px" }} className="printable-content" key={index}>
                              {projectExpireance(e)}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {resumeData?.Certification?.length > 0 && (
            <div className="section educ-sec SECTION_EDUC   multi-para has-title  " id="certification">
              <div className=" doc-item">
                <div className="heading">
                  <div className="sectiontitle">
                    Certification<span className="rename-section text-rename"></span>
                  </div>
                </div>
                <div>
                  <div className="paragraph PARAGRAPH_EDUC firstparagraph">
                    <div className="clearfix doc-item">
                      <div className="singlecolumn">
                        <ul>
                          {resumeData?.Certification.map((certification, index) => (
                            <li key={index} style={{ padding: "5px" }}>
                              {certification?.certificationName}-{certification?.issuingOrganization}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {resumeData?.Award?.length > 0 && (
            <div className="section educ-sec SECTION_EDUC   multi-para has-title  " id="award">
              <div className=" doc-item">
                <div className="heading">
                  <div className="sectiontitle">
                    Award<span className="rename-section text-rename"></span>
                  </div>
                </div>
                <div>
                  <div>
                    <div className="paragraph PARAGRAPH_EDUC firstparagraph">
                      <div className="clearfix doc-item">
                        <div className="singlecolumn">
                          <ul>
                            {resumeData?.Award.map((award, index) => (
                              <>
                                <h3>
                                  <span>{award?.dateReceived} </span>
                                  <span>{award?.awardingOrganization} </span>
                                </h3>
                                <li key={index} style={{ padding: "5px" }}>
                                  {award?.awardName}
                                </li>
                              </>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {resumeData?.Hobby?.length > 0 && (
            <div className="section educ-sec SECTION_EDUC   multi-para has-title  " id="hobby">
              <div className=" doc-item">
                <div className="heading">
                  <div className="sectiontitle">
                    Hobby<span className="rename-section text-rename"></span>
                  </div>
                </div>
                <div>
                  <div>
                    <div className="paragraph PARAGRAPH_EDUC firstparagraph">
                      <div className="clearfix doc-item">
                        <div className="singlecolumn">
                          <ul style={{ display: "flex", flexWrap: "wrap" }}>
                            {resumeData?.Hobby.map((hobby, index) => (
                              <li className="skills" key={index}>
                                {hobby}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {resumeData?.Language?.length > 0 && (
            <div className="section lang-sec infobarsec SECTION_LNGG    has-title  " id="language">
              <div className=" doc-item">
                <div className="heading">
                  <div className="sectiontitle">
                    Languages<span title=" Languages " className="rename-section text-rename"></span>
                  </div>
                </div>
                <div className="sortableInner">
                  <div className="sortable-item paragraph-container SortableItem-sibling ">
                    <div className="paragraph PARAGRAPH_LNGG firstparagraph  nativeLangPara">
                      <div className="clearfix doc-item">
                        <div className="singlecolumn infobarpara">
                          <div className="field">
                            {resumeData?.Language.map((language, index) => (
                              <>
                                <span className="txt-bold">{language?.languageName}</span>
                                <span className="colon">:</span>
                                <div className="field field-ratt">
                                  <span>{language?.proficiencyLevel}</span>
                                </div>
                              </>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
